// extracted by mini-css-extract-plugin
module.exports = {"button":"_26qP-aD78zaL066yWZHNXq","icon":"_3_L6c6lYGlgXd2nMIOJFN0"};